<template>
  <BaseNoticeItem>
    <template #head>
      <strong>
        {{ $t(title) }}
      </strong>
    </template>
    <template #body>
      <div>
        {{ $t(description) }}
      </div>
    </template>
  </BaseNoticeItem>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import BaseNoticeItem from '@/components/BaseNoticeItem.vue'
import { $t } from '@/composables/translation'

interface Props {
  complianceData?: {
    status?: string
    status_title?: string
    status_description?: string
  }
}

const props = withDefaults(defineProps<Props>(), {
  complianceData: undefined,
})

const title = computed(() => {
  if (props.complianceData?.status_title) {
    return props.complianceData.status_title
  }
  return 'Background Checks In Progress'
})

const description = computed(() => {
  if (props.complianceData?.status_description) {
    return props.complianceData.status_description
  }
  return "Background checks have been initiated. The contract will be available for signature once all checks are complete. The worker's start date may be adjusted based on the completion of the background checks."
})
</script>
